import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '케어인슈와 다른 보험의 가장 큰 차이점은 무엇인가요?',
      answer: '케어인슈는 20년간 축적된 장기요양시설 전문 데이터를 기반으로 한 자사경험요율을 적용하여 타사 대비 15-20% 낮은 보험료를 제공합니다. 또한 사고를 명확히 구분하여 불필요한 보험금 지급을 방지하고, 사고 발생 시에도 합리적인 할증으로 재가입이 보장됩니다.'
    },
    {
      question: '사고가 발생하면 다음 해에 보험 가입이 거절되나요?',
      answer: '아닙니다. 케어인슈는 사고 발생 시에도 재가입을 보장합니다. 다만 사고의 종류와 과실 정도에 따라 합리적인 수준의 할증이 적용될 수 있습니다. 이는 시설이 지속적으로 보험 보호를 받을 수 있도록 하기 위한 케어인슈만의 차별화된 정책입니다.'
    },
    {
      question: '자연 발생 사고도 보험 처리가 되나요?',
      answer: '자연 발생 사고는 시설의 과실이 없는 경우로, 보험금 지급 대상이 아닙니다. 예를 들어 기저질환의 자연스러운 악화나 노화로 인한 건강 악화 등이 이에 해당합니다. 케어인슈는 전담 손해사정사가 정밀하게 사고를 분석하여 시설 과실 여부를 공정하게 판단합니다.'
    },
    {
      question: '보험료는 어떻게 산정되나요?',
      answer: '입소시설의 경우 정원과 현원을 기준으로, 방문시설의 경우 요양보호사 및 돌보미 수를 기준으로 보험료가 산정됩니다. 여기에 시설의 사고 이력, 안전 관리 수준 등을 종합적으로 고려하여 최종 보험료가 결정됩니다.'
    },
    {
      question: '평가·운영 지원 서비스는 어떻게 받을 수 있나요?',
      answer: '케어인슈 가입 시설은 할인된 금액으로 평가 대비 컨설팅과 운영 개선 지원 서비스를 받으실 수 있습니다. 상담 신청을 통해 전담 컨설턴트가 배정되며, 시설의 필요에 맞는 맞춤형 지원이 제공됩니다.'
    },
    {
      question: '손해사정은 얼마나 걸리나요?',
      answer: '사고 접수 후 24시간 내에 전담 손해사정사가 배정되어 신속하게 현장 조사를 시작합니다. 사고의 복잡도에 따라 다르지만, 일반적으로 2-4주 내에 손해사정이 완료되며, 보험금 지급 승인 후 즉시 보험금이 지급됩니다.'
    },
    {
      question: '중도에 시설 규모가 변경되면 어떻게 하나요?',
      answer: '시설의 정원, 현원, 인력 수 등이 변경되는 경우 즉시 보험사에 알려주셔야 합니다. 변경 사항에 따라 보험료가 조정되며, 추가 보험료 납부 또는 환급이 이루어집니다. 정확한 정보 제공은 보험금 지급 시 분쟁을 예방하는 데 중요합니다.'
    },
    {
      question: '다른 보험사에서 가입 거절당했는데 케어인슈는 가능한가요?',
      answer: '케어인슈는 사고 이력이 있는 시설도 합리적인 조건으로 가입할 수 있도록 지원합니다. 다만 사고의 종류와 빈도, 시설의 개선 노력 등을 종합적으로 검토하여 가입 여부와 조건이 결정됩니다. 상담을 통해 구체적인 가입 가능 여부를 확인하실 수 있습니다.'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-br from-white via-[#F3E8FF] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#A855F7]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#A855F7]/5 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 bg-[#A855F7]/10 text-[#A855F7] text-sm font-semibold rounded-full mb-6">
            FAQ
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            자주 묻는 질문
          </h2>
          <p className="text-base text-gray-600">
            케어인슈에 대해 궁금하신 점을 확인해보세요
          </p>
        </div>

        {/* FAQ Image */}
        <div className="mb-16 relative group">
          <div className="absolute inset-0 bg-gradient-to-br from-[#A855F7]/20 to-transparent rounded-3xl transform rotate-1 group-hover:-rotate-1 transition-transform duration-500"></div>
          <img 
            src="https://public.readdy.ai/ai/img_res/43af810c136291ee6def3e47d2e0e466.jpg"
            alt="자주 묻는 질문"
            className="relative rounded-3xl shadow-2xl w-full h-[300px] object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
          />
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border-2 border-[#A855F7]/20 overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-[#A855F7]/5 transition-colors"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div className="w-10 h-10 bg-[#A855F7]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold text-[#A855F7]">Q{index + 1}</span>
                  </div>
                  <h3 className="text-base font-bold text-gray-900 pr-4">{faq.question}</h3>
                </div>
                <div className={`w-8 h-8 bg-[#A855F7]/10 rounded-lg flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-[#A855F7] text-xl"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 pt-2">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#A855F7]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-sm font-bold text-[#A855F7]">A</span>
                    </div>
                    <p className="text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 bg-gradient-to-br from-[#A855F7]/10 to-[#A855F7]/5 rounded-3xl p-12 text-center border-2 border-[#A855F7]/20">
          <div className="w-16 h-16 bg-[#A855F7]/10 rounded-2xl flex items-center justify-center mb-6 mx-auto">
            <i className="ri-question-answer-line text-3xl text-[#A855F7]"></i>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            더 궁금하신 점이 있으신가요?
          </h3>
          <p className="text-base text-gray-600 mb-8">
            케어인슈 전문 컨설턴트가 친절하게 답변해 드립니다
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('consultation');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }}
            className="px-10 py-4 bg-[#A855F7] text-white text-base font-semibold rounded-2xl hover:bg-[#9333EA] transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            상담 신청하기
          </button>
        </div>
      </div>
    </section>
  );
}
